import React, { useState } from "react";
import add from "../../images/add.svg";
import deleteIcon from "../../images/delete.png";
import detailIcon from "../../images/detail.png";
import editIcon from "../../images/edit.png";
import RackRepository from "../../Repository/RackRepository";
import { Button, Grid, Stack, Typography, Box } from "@mui/material";
import DialogComponent from "../reusableComponents/Dialog";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { ButtonDelete, ButtonDetail, DialogInput } from "./styles";
import { ButtonEdit, RackBox, Title } from "./styles";
import Loader from "../components/Loader";
import useGetRacks from "./useGetRacks";

const schema = yup
  .object()
  .shape({
    mainRack: yup.string().required("Required"),
    subRack: yup.string().required("Required"),
  })
  .required();

function Racks() {
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [rack, setRack] = useState({
    loading: false,
    selectedRack: "",
    subRack: "",
  });
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const { loading, racks, getRacks } = useGetRacks();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const addToggle = () => {
    setAddModal((state) => !state);
  };
  const editToggle = (item) => {
    if (item) {
      setRack((state) => ({ ...state, selectedRack: item, subRack: "" }));
    } else {
      setRack((state) => ({ ...state, selectedRack: "", subRack: "" }));
    }
    setEditModal((state) => !state);
  };
  const deleteToggle = (item) => {
    setRack((state) => ({ ...state, selectedRack: item }));
    setDeleteModal((state) => !state);
  };

  const Register = async (arg) => {
    addToggle();
    let racksData = {
      name: arg.mainRack,
      sub_rack: [arg.subRack],
    };
    let { data } = await RackRepository.RackModel({
      request: {
        method: "saveRack",
        data: {
          company_code: localStorage.getItem("companyCode"),
          racks: racksData,
        },
      },
    });
    toast.configure();
    toast.success("New Location Added Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    getRacks();
  };

  const updateRack = async () => {
    let copy = JSON.parse(JSON.stringify(rack.selectedRack));
    if (rack.subRack) {
      copy.racks.sub_rack = [...copy.racks.sub_rack, rack.subRack];
    }

    await RackRepository.RackModel({
      request: {
        method: "updateRack",
        data: copy,
      },
    });
    editToggle();
    toast.configure();
    toast.success("Updated Successfuly", {
      position: toast.POSITION.TOP_RIGHT,
    });
    getRacks();
  };

  const searchedItems = () => {
    if (searchText != "") {
      const filtered = racks.filter((item) =>
        item.racks.name.toLowerCase().includes(searchText)
      );
      return filtered;
    } else {
      return racks;
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const deleteRack = async () => {
    await RackRepository.RackModel({
      request: {
        method: "deleteRack",
        data: {
          company_code: localStorage.getItem("companyCode"),
          rack_code: rack.selectedRack._id,
        },
      },
    });
    deleteToggle();
    toast.configure();
    toast.success("Location Deleted Successfuly", {
      position: toast.POSITION.TOP_RIGHT,
    });
    getRacks();
  };

  const detailToggle = (item) => {
    history.push({
      pathname: "/inventory/admin/location-details",
      state: {
        rack: item,
      },
    });
  };

  const handleChange = (e) => {
    let copy = JSON.parse(JSON.stringify(rack.selectedRack));
    copy.racks.name = e.target.value;

    setRack((state) => ({
      ...state,
      selectedRack: copy,
    }));
  };
  const handleSubRack = (e) => {
    let current = e.target.value;
    setRack((state) => ({
      ...state,
      subRack: current,
    }));
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={searchText}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={7.5} md={5} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Locations
            </Typography>
          </Grid>
          <Grid
            align="center"
            item
            lg={1.5}
            md={4}
            xs={12}
            style={{ marginLeft: "-12px" }}
          >
            <ButtonAdd
              variant="contained"
              sx={{ width: { md: "100%", xs: "90%" } }}
              onClick={addToggle}
            >
              Add <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer>
        {searchedItems().map((item, index) => {
          return (
            <RackBox
              key={index}
              container
              spacing={1}
              columns={24}
              className="rack-box"
            >
              <Grid item xs={1}>
                <Typography style={{ color: "#4EAF50" }}>
                  {index + 1}:
                </Typography>
              </Grid>
              <Grid item md={11} xs={23}>
                <Typography style={{ color: "#4EAF50" }}>
                  {item.racks.name}
                </Typography>
              </Grid>
              <Grid item align="center" md={4} xs={8}>
                <ButtonEdit fullWidth onClick={() => editToggle(item)}>
                  Edit
                  <img
                    style={{ marginLeft: "10px" }}
                    src={editIcon}
                    alt="add"
                  />
                </ButtonEdit>
              </Grid>
              <Grid item align="center" md={4} xs={8}>
                <ButtonDetail fullWidth onClick={() => detailToggle(item)}>
                  Details
                  <img
                    style={{ marginLeft: "10px" }}
                    src={detailIcon}
                    alt="add"
                  />
                </ButtonDetail>
              </Grid>
              <Grid item align="center" md={4} xs={8}>
                <ButtonDelete fullWidth onClick={() => deleteToggle(item)}>
                  Delete
                  <img
                    style={{ marginLeft: "10px" }}
                    src={deleteIcon}
                    alt="add"
                  />
                </ButtonDelete>
              </Grid>
            </RackBox>
          );
        })}
      </BodyContainer>

      <DialogComponent
        title="Add Location"
        open={addModal}
        onClose={addToggle}
        onClickCancel={addToggle}
        dialogContent={
          <>
            <Title>Create New Location !</Title>
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Enter Location name :
            </Typography>
            <DialogInput
              fullWidth
              variant="outlined"
              placeholder="Main Location"
              {...register("mainRack")}
            />
            <Typography style={{ color: "red" }}>
              {errors.mainRack?.message}
            </Typography>
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Enter sub-location name :
            </Typography>
            <DialogInput
              fullWidth
              variant="outlined"
              placeholder="Sub Location"
              {...register("subRack")}
            />
            <Typography style={{ color: "red" }}>
              {errors.subRack?.message}
            </Typography>
            <Stack direction="row" spacing={5}>
              <Button
                fullWidth
                variant="outlined"
                sx={{ color: "white", background: "#8A8A8A !important" }}
                onClick={addToggle}
              >
                Cancel
              </Button>

              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmit(Register)}
              >
                Add
              </Button>
            </Stack>
          </>
        }
      />
      <DialogComponent
        title="Edit Location"
        open={editModal}
        onClose={editToggle}
        onClickCancel={editToggle}
        dialogContent={
          <>
            <Title>Edit Location</Title>
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Location name :
            </Typography>
            <DialogInput
              fullWidth
              variant="outlined"
              value={rack?.selectedRack?.racks?.name}
              onChange={handleChange}
            />
            <Box style={{ display: "flex" }}>
              {rack?.selectedRack?.racks?.sub_rack.map((item, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      border: "solid 1px #4EAF50",
                      margin: "3px",
                      padding: "6px",
                    }}
                  >
                    {item}
                  </Box>
                );
              })}
            </Box>
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Add Sub Location:
            </Typography>
            <DialogInput
              fullWidth
              variant="outlined"
              value={rack.subRack}
              onChange={handleSubRack}
            />
            <Stack direction="row" spacing={5}>
              <Button
                fullWidth
                sx={{ color: "white", background: "#8A8A8A !important" }}
                onClick={editToggle}
              >
                Cancel
              </Button>

              <Button fullWidth variant="contained" onClick={updateRack}>
                Update
              </Button>
            </Stack>
          </>
        }
      />

      <DeleteDialog
        title="Delete Rack"
        open={deleteModal}
        onClose={deleteToggle}
        onClickYes={deleteRack}
      />
      <Loader loading={rack.loading || loading} />
    </Box>
  );
}

export default Racks;
